import React from "react";
import "../Styles/Contact.css";

const Query = () => {
  return (
    <>
    
    <div className="contact-image">
      <img src="./corporate/connect.png " alt="" />
    </div>

    <section className="contact-section">
      <h1 className="contact-title">Send Your Query</h1>
      {/* MAP + FORM */}
      <section className="map-form-wrapper" id="map">
        

        {/* FORM */}
        <div className="contact-form">
          {/* <h3>Send Your Query</h3> */}
          <p>
           <strong> Please connect with us for project inquiry, feedback or grievance.</strong>
          </p>

          <form>
            <input type="text" placeholder="Name" />
            <input type="email" placeholder="Email Address" />
            <textarea placeholder="Message" rows="5"></textarea>
            <button type="submit">SUBMIT</button>
          </form>
        </div>

        
      </section>
       
    </section>

    </>
  );
};

export default Query;


